import qs from 'qs';

const parseUrlQueryString = (query: string) =>
  qs.parse(query, {
    ignoreQueryPrefix: true,
    allowDots: true,
  });

export default parseUrlQueryString;
